import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";


export const studentApi = createApi({
  reducerPath: "studentApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["Student"],
  endpoints: (builder) => ({

    getStudentList: builder.mutation({
      query: (payload) => ({
        url: `auth/v1/student/get/list`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Student"],
    }),

    getStudentDetails: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    studentBlockUnBlock: builder.mutation({
      query: ({ sid, status }) => ({
        url: `auth/v1/user/blockstatus/${sid}/${status}`,
        method: "POST",
      }),
      invalidatesTags: ["Student"],
    }),
    studentSuspendUnsuspend: builder.mutation({
      query: ({ sid, status }) => ({
        url: `auth/v1/user/suspenstatus/${sid}/${status}`,
        method: "POST",
      }),
      invalidatesTags: ["Student"],
    }),
    getStudentActivityList: builder.query({
      query: ({ uid, page = 1, limit = 10, startDate = null, endDate = null }) =>
        `auth/v1/student/fetch/activity/list/${uid}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`,
    }),
    getExamList: builder.query({
      query: (endPoint) => `${endPoint}`
    }),
    getCourseList: builder.query({
      query: (endPoint) => `${endPoint}`
    }),
    // getLogsList: builder.query({
    //   query: (endPoint) => `${endPoint}`
    // }),
    // getLogsList: builder.query({
    //   query: ({ page, limit }) =>
    //     `auth/v1/student/get/iverse/logs?page=${page}&limit=${limit}`,
    // }),
    // getLogsList: builder.query({
    //   query: ({ page, limit, statusCode, ip, url, method, createdAt }) => {
    //     const params = new URLSearchParams();

    //     params.append("page", page);
    //     params.append("limit", limit);

    //     if (statusCode) params.append("statusCode", statusCode);
    //     if (ip) params.append("ip", ip);
    //     if (url) params.append("url", url);
    //     if (method) params.append("method", method);
    //     if (createdAt) params.append("createdAt", createdAt);

    //     return `auth/v1/student/get/iverse/logs?${params.toString()}`;
    //   },
    // }),
    getLogsList: builder.query({
  query: ({ page, limit, statusCode, ip, url, method, filterType, startDate, endDate }) => {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("limit", limit);

    if (statusCode) params.append("statusCode", statusCode);
    if (ip) params.append("ip", ip);
    if (url) params.append("url", url);
    if (method) params.append("method", method);
    if (filterType) params.append("filterType", filterType);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    return `auth/v1/student/get/iverse/logs?${params.toString()}`;
  },
}),


  }),

});

export const {
  // useGetStudentListQuery,
  useGetStudentListMutation,
  useGetStudentDetailsQuery,
  useStudentBlockUnBlockMutation,
  useStudentSuspendUnsuspendMutation,
  useGetStudentActivityListQuery,
  useGetExamListQuery,
  useGetCourseListQuery,
  useGetLogsListQuery,

} = studentApi;


